// src/app/modules/auth/models/user.model.ts

import { AuthModel } from './auth.model';

export class UserModel extends AuthModel {
  id?: number;
  username?: string;
  password?: string;
  fullname?: string;  // using "fullname"
  email?: string;
  pic?: string;
  roles: number[] = [];
  occupation?: string;
  companyName?: string;
  phone?: string;
  mobile?: string;
  // optional address, social networks, etc.
  firstname?: string;
  lastname?: string;
  website?: string;
  language?: string;
  timeZone?: string;
  communication?: {
    email?: boolean;
    sms?: boolean;
    phone?: boolean;
  };
  // MFA fields (previously from /auth/me; may be populated via separate endpoints)
  declare mfa_verify_required?: boolean;
  mfa_status?: {
    enabled: boolean;
    type: string;
    methods: any[];
  };
  declare mfa_last?: string;
  /** Effective search debounce ms (system default or user override). */
  search_debounce_ms?: number;
  search_debounce_ms_default?: number;
  search_debounce_ms_override?: number | null;
  emailSettings?: {
    emailNotification?: boolean;
    sendCopyToPersonalEmail?: boolean;
    activityRelatesEmail?: {
      youHaveNewNotifications?: boolean;
      youAreSentADirectMessage?: boolean;
      someoneAddsYouAsAsAConnection?: boolean;
      uponNewOrder?: boolean;
      newMembershipApproval?: boolean;
      memberRegistration?: boolean;
    };
    updatesFromKeenthemes?: {
      newsAboutKeenthemesProductsAndFeatureUpdates?: boolean;
      tipsOnGettingMoreOutOfKeen?: boolean;
      thingsYouMissedSindeYouLastLoggedIntoKeen?: boolean;
      newsAboutMetronicOnPartnerProductsAndOtherServices?: boolean;
      tipsOnMetronicBusinessProducts?: boolean;
    };
  };

  // Similar to your original setUser method
  setUser(_user: unknown) {
    const user = _user as UserModel;
    this.id = user.id;
    this.username = user.username || '';
    this.password = user.password || '';
    this.fullname = user.fullname || '';
    this.email = user.email || '';
    this.pic = user.pic || './assets/media/avatars/blank.png';
    this.roles = user.roles || [];
    this.occupation = user.occupation || '';
    this.companyName = user.companyName || '';
    this.phone = user.phone || '';

    // We skip address, socialNetworks or handle them if provided:
    // this.address = user.address;
    // this.socialNetworks = user.socialNetworks;

    // If we used any AuthModel fields:
    this.authToken = user.authToken;
    this.refreshToken = user.refreshToken;
    this.expiresIn = user.expiresIn;
  }
}
